import { useQuery } from '@gogame/query';
import { loadChats } from 'scenes/AIChatbot/sources/chats';
import { chats } from './queryKeyFactory';

export const useLoadChats = () => {
  return useQuery(chats, (_, { signal }) => loadChats({}, { signal }), {
    initialData: [],
  });
};
